import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, onMounted, onUnmounted } from 'vue';
import axios from 'axios';
import Cookies from 'js-cookie';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';
import { useStore } from 'vuex';

import sendMetrics from '../src/components/sendMetrics/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { track } = useTrack();

const isDDE = process.env.VUE_APP_IS_DDE == 'true';
const appCode = process.env.VUE_APP_OAUTH_APPCODE;
const appType = process.env.VUE_APP_APP_TYPE;
const AUTH_MODE = process.env.VUE_APP_AUTH_MODE || (isDDE ? 'dde' : (appType === 'geovisearth' ? 'geovisearth' : 'mapscloud'));
const store = useStore();

const data = reactive({
  trackServer: process.env.VUE_APP_TRACK_SERVER,
  channel: process.env.VUE_APP_TRACK_CHANNEL,
  timer: 0,
});

const fetchApiKey = (callback) => {
  axios({
    method: 'POST',
    url: process.env.VUE_APP_TRACK_SERVER_TOKEN,
    data: {
      channel: 'globallayer',
    },
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data, status }) => {
    if (status === 200) {
      Cookies.set('apiKey', data.data);
    }
    if (callback) {
      callback();
    }
  });
};

onMounted(() => {
  if (isDDE) {
    fetchApiKey(() => {
      track(FunctionIdEnum.globalLayer_page_open, EventTypeEnum.PAGE_OPEN);
    });
    data.timer = setInterval(fetchApiKey, 5 * 1000 * 60);
  }

  if (AUTH_MODE === 'dde') {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        axios.get(`/ngiam-rst/oauth2/validate?appcode=${appCode}&token=${accessToken}`).then((response) => {
          console.log('response.data', JSON.stringify(response.data, null, 2))
          const { code, data } = response.data;
          if (code == 'SUCCESS' && data) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('accountName');
            window.location.href = `https://user-oneid.deep-time.org/ngiam-rst/cas/logout?context=${encodeURIComponent(window.location.href)}`
          }
        });
      } catch (error) {
        console.error('Error validate token:', error);
      }
    }
  } else if (AUTH_MODE === 'carto') {
    store.dispatch('auth/getCartoSessionConfig');
  } else {
    store.dispatch('auth/getCartodbConfig');
  }
});

onUnmounted(() => {
  clearInterval(data.timer);

  window.onload = null;
  window.onbeforeunload = null;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    isDDE
      ? (_openBlock(), _createBlock(sendMetrics, {
          key: 0,
          channel: data.channel,
          targetUrl: data.trackServer
        }, null, 8, ["channel", "targetUrl"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})